import { DialogProps } from '@material-ui/core';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { healthInsuranceFundMetaCommand_patchThirdPayerArrangementAddress, IAddressModel, IHealthInsuranceFundWithAddressDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo, useState } from 'react';
import { AddressModelForm } from 'shared/address/AddressModelForm';
import { AlsoUpdateAdvisoryPhysicianAddressForm } from './AlsoUpdateAdvisoryPhysicianAddressForm';
import { toModel } from './toModel';

interface IProps extends DialogProps {
	item: IHealthInsuranceFundWithAddressDto;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const PatchHifThirdPayerArrangementAddressForm = ({ item, confirm, cancel, ...rest }: IProps) => {
	const [address, setAddress] = useState<IAddressModel>();
	const [patch, isSubmitting] = useFormSubmit(healthInsuranceFundMetaCommand_patchThirdPayerArrangementAddress);
	const strings = useLocalization();
	const title = useMemo(() => `${strings.changeWhat(`${strings.address} ${strings.thirdPayerArrangement}`)}`, [strings]);

	const onSubmit = async (address: IAddressModel, alsoUpdate: boolean) => {
		const r = await patch({ address: address, hifCode: item.code, isUseSame: alsoUpdate });
		if (r.isSuccess) {
			confirm();
		}
	};

	if (address === undefined) {
		return (
			<AddressModelForm
				{...rest}
				cancel={cancel}
				confirm={setAddress}
				initialValue={toModel(item.thirdPayerArrangementAddress)}
				title={title}
			/>
		);
	} else {
		return (
			<AlsoUpdateAdvisoryPhysicianAddressForm
				{...rest}
				confirm={alsoUpdate => onSubmit(address!, alsoUpdate)}
				cancel={cancel}
				isSubmitting={isSubmitting}
				title={title}
			/>
		);
	}
};
